<div class="pa-gauge">
  <svg viewBox="0 0 120 74">
    <path d="M 10 60 A 50 50 0 0 1 110 60" fill="none" stroke="var(--pa-divider)" stroke-width="12" stroke-linecap="round"></path>
    <path d="M 10 60 A 50 50 0 0 1 110 60" fill="none" [attr.stroke]="color" stroke-width="12" stroke-linecap="round"
      [attr.stroke-dasharray]="dash + ' ' + L"></path>
    <line *ngIf="limit > 0" [attr.x1]="tick.x1" [attr.y1]="tick.y1" [attr.x2]="tick.x2" [attr.y2]="tick.y2" stroke="var(--pa-navy)" stroke-width="2"></line>
    <text x="60" y="50" text-anchor="middle" class="pa-gauge__val">{{ displayValue }}</text>
    <text x="60" y="70" text-anchor="middle" class="pa-gauge__lbl" *ngIf="label">{{ label }}</text>
  </svg>
</div>
